import { Box } from "@chakra-ui/react";
import LineGraph from "../../daily/LineGraph";
import { formatNumber } from "../../../store/helpers";
import ReportDataTable from "../../reports/ReportDataTable";
import { CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS } from "../../../store/renderConfig";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../store/reportEnterpriseInsights";

const renderCustomerCell = (row, columnId) => {
  if (columnId === "scopeName") return row.scopeName || row.branchName;
  if (columnId === "total") return formatNumber(row.total);
  if (columnId === "min") return formatNumber(row.min);
  if (columnId === "max") return formatNumber(row.max);
  if (columnId === "average") return formatNumber(row.average);
  if (columnId === "abandonmentRate") return formatNumber(row.abandonmentRate ?? row.abondonmentRate);
  if (columnId === "peakHour") return row.peakHour;
  return null;
};

const CustomersInBranchPerHour = ({ data, reportIndex, renderConfig, onRenderConfigChange }) => {
  return (
    <Box>
      <Box>
        {data.map((data, index) => {
          const { branchName, chart, average, total, max, min } = data;
          const title = `${reportIndex || ""}.${index + 1}. ${branchName}`;
          const tableRows = [{ ...data, scopeName: branchName }];
          const insights = buildArrivalInsights(
            [{ ...data, scopeName: branchName, max: max, min: min, average: average }],
            { scopeLabel: "Branch" }
          );
          if (!renderConfig?.charts?.enabled) {
            return (
              <Box key={index} className="customersInBranchBlock">
                <h2>{title}</h2>
                <EnterpriseReportSummary
                  title="Customers In Branch Summary"
                  kpis={insights.kpis}
                  tables={insights.tables}
                  notes={insights.notes}
                />
                <ReportDataTable
                  columns={CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS}
                  rows={tableRows}
                  renderConfig={renderConfig}
                  renderCell={renderCustomerCell}
                  onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
                />
              </Box>
            );
          }

          return (
            <Box key={index}>
              <h2>{title}</h2>
              <EnterpriseReportSummary
                title="Customers In Branch Summary"
                kpis={insights.kpis}
                tables={insights.tables}
                notes={insights.notes}
              />
              <Box mt={4}>
                <ReportDataTable
                  columns={CUSTOMERS_IN_BRANCH_COLUMN_DEFINITIONS}
                  rows={tableRows}
                  renderConfig={renderConfig}
                  renderCell={renderCustomerCell}
                  onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
                />

                <Box mt="20px" mb="20px" pt={"10px"}>
                  <LineGraph
                    chart={chart}
                    title={`${branchName} Number of Customers in Branch, Hour by Hour Comparison`}
                    lineName="Customers"
                  />
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default CustomersInBranchPerHour;
